<template lang="pug">
  v-select(
    v-model="p_code"
    :items="masterList"
    item-text="label"
    :item-value="itemValue"
    :clearable="clearable"
    label="出力状態"
    :error-messages="errorHandlerMethod(errorHandlerMethodArgComputed)")
</template>

<script>
import * as Enum from "@/assets/js/enum";
export default {
  props: {
    // TODO:type:Boolean 必須でありながらNullがはいる可能性があるため回避。（※clearable影響）
    // eslint-disable-next-line vue/require-prop-types
    code: {
      required: true
    },
    errorHandlerMethod: {
      type: Function,
      default() {
        return null;
      }
    },
    errorHandlerMethodArg: {
      type: String,
      default() {
        return null;
      }
    },
    useFilter: {
      type: Boolean,
      default() {
        return false;
      }
    },
    clearable: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      defaultErrorHandlerMethodArg: "reportOutputStatusType"
    };
  },
  computed: {
    p_code: {
      get() {
        return this.code;
      },
      set(newVal) {
        if (this.code !== newVal) this.$emit("update:code", newVal);
      },
      required: true
    },
    masterList: {
      get() {
        return Enum.Utils.enumToList(Enum.ReportOutputStatusType);
      }
    },
    errorHandlerMethodArgComputed: {
      get() {
        if (this.errorHandlerMethodArg == null) {
          return this.defaultErrorHandlerMethodArg;
        }
        return this.errorHandlerMethodArg;
      }
    },
    itemValue: {
      get() {
        if (this.useFilter) {
          return "label";
        } else {
          return "code";
        }
      }
    }
  },
  methods: {}
};
</script>

<style scoped></style>
